<div class="container">
  <div class="modal-header">
    <p class="switch lock" *ngIf="deviceAction == deviceActions.Lock">
      <i class="fa fa-lock"></i><span>{{ 'label_Lock' | xsI18n }}</span>
    </p>

    <p class="switch wipe" *ngIf="deviceAction == deviceActions.Wipe">
      <i class="fa famc famc-action-wipe"></i><span>{{ 'label_Wipe' | xsI18n }}</span>
    </p>

    <p class="switch message" *ngIf="deviceAction == deviceActions.SendMessage">
      <i class="fa fa-envelope"></i><span>{{ 'label_Message' | xsI18n }}</span>
    </p>

    <p class="switch unenroll" *ngIf="deviceAction == deviceActions.UnEnroll">
      <i class="fa famc famc-action-un-enroll"></i><span>{{ 'label_UnEnroll' | xsI18n }}</span>
    </p>

    <p class="switch checkin" *ngIf="deviceAction == deviceActions.CheckIn">
      <i class="fa fa-fw fa-repeat"></i><span>{{ 'label_CheckIn' | xsI18n }}</span>
    </p>

    <p class="switch resetpwd" *ngIf="deviceAction == deviceActions.ResetPasscode">
      <i class="fa fa-key"></i><span>{{ 'label_ResetPasscode' | xsI18n }}</span>
    </p>

    <p class="switch removepwd" *ngIf="deviceAction == deviceActions.RemovePasscode">
      <i class="fa fa-key"></i><span>{{ 'label_RemovePasscode' | xsI18n }}</span>
    </p>

    <p class="switch locate" *ngIf="deviceAction == deviceActions.Locate">
      <i class="fa famc famc-action-locate"></i><span>{{ 'label_Locate' | xsI18n }}</span>
    </p>

  </div>

  <div class="modal-body">
    <p class="switch lock" *ngIf="deviceAction == deviceActions.Lock">
      <span>{{ 'message_Lock' | xsI18n }}</span>
    </p>

    <p class="switch wipe" *ngIf="deviceAction == deviceActions.Wipe">
      <span>{{ 'message_Wipe' | xsI18n }}</span>
    </p>

    <p class="switch message" *ngIf="deviceAction == deviceActions.SendMessage">
      <span>{{ 'message_SendMessage' | xsI18n }}</span>
    </p>

    <p class="switch unenroll" *ngIf="deviceAction == deviceActions.UnEnroll">
      <span>{{ 'message_UnEnroll' | xsI18n }}</span>
    </p>

    <p class="switch checkin" *ngIf="deviceAction == deviceActions.CheckIn">
      <span>{{ 'message_CheckIn' | xsI18n }}</span>
    </p>

    <p class="switch resetpwd" *ngIf="deviceAction == deviceActions.ResetPasscode">
      <span>{{ 'message_ResetPasscode' | xsI18n }}</span>
    </p>

    <p class="switch removepwd" *ngIf="deviceAction == deviceActions.RemovePasscode">
      <span>{{ 'message_RemovePasscode' | xsI18n }}</span>
    </p>

    <p class="switch locate" *ngIf="deviceAction == deviceActions.Locate">
      <span>{{ 'message_Locate' | xsI18n }}</span>
    </p>

    <form [formGroup]="ui.params" class="ssp-form" novalidate>
      <div *ngIf="ui.bFormLock">
        <div class="form-group">
          <input type="text" class="form-control" formControlName="phone" mc-stop-event="touchend" />
          <div class="label-title">{{ 'label_EmergencyPhoneNumber' | xsI18n }}</div>
        </div>
        <div class="form-group">
          <textarea class="form-control" rows="3" formControlName="message" mc-stop-event="touchend"></textarea>
          <div class="label-title">{{ 'label_lockScreenMessage' | xsI18n }}</div>
        </div>
        <div class="form-group" *ngIf="ui.checkForMacDevice">
          <input type="password" class="form-control" formControlName="password" mc-stop-event="touchend" />
          <div class="label-title">{{ 'label_NewPinOnMac' | xsI18n }}</div>
        </div>
      </div>

      <div *ngIf="ui.bFormWipe">
        <div class="form-group" *ngIf="ui.checkForMacDevice">
          <input type="password" class="form-control" formControlName="password" mc-stop-event="touchend" />
          <div class="label-title">{{ 'label_NewPinOnMac' | xsI18n }}</div>
        </div>
      </div>

      <div *ngIf="ui.bFormMsg">
        <div class="form-group">
          <textarea
            class="form-control"
            rows="4"
            formControlName="message"
            name="txtMessage"
            required
            mc-stop-event="touchend"
          ></textarea>
          <div class="error-labels" *ngIf="paramsControls.message.invalid && paramsControls.message.touchend">
            <div class="label-invalid">{{ 'message_MandatoryField' | xsI18n }}</div>
          </div>
        </div>
      </div>

      <div *ngIf="ui.bFormPwd">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="{{ 'label_NewPassword' | xsI18n }}"
            formControlName="password"
            mc-stop-event="touchend"
          />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-default"
      (click)="onDialogCancel()"
      [ngClass]="{
        'wipe-unEnroll-cancel': isWipeUnEnroll,
        cancel: !isWipeUnEnroll
      }"
    >
      <span>{{ 'xs_cancel_label_short' | xsI18n }}</span>
    </button>

    <button
      class="btn btn-default"
      [ngClass]="{
        'wipe-unEnroll-apply': isWipeUnEnroll,
        apply: !isWipeUnEnroll
      }"
      (click)="onDialogSubmit()"
      [disabled]="paramsControls.invalid"
    >
      {{ ui.buttonText }}
    </button>
  </div>
</div>
